"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var PartnersList_1 = require("./component/PartnersList");
var PartnerEditor_1 = require("./component/PartnerEditor");
var PartnerConfig_1 = require("./component/PartnerConfig");
var notificationHelper_1 = require("../../../../../shared/helpers/notificationHelper");
var PPartnersList = /** @class */ (function (_super) {
    __extends(PPartnersList, _super);
    function PPartnersList(props) {
        return _super.call(this, props) || this;
    }
    PPartnersList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AA = this.props.listAffilatesAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_affilates: data.data });
        });
        this.SID_AC = this.props.listAppCurrencyAvail.Subscribe("*", function (id, data) {
            _this.setState({ app_currency_avail: data.data });
        });
        this.SID_AL = this.props.listAppLanguageAvail.Subscribe("*", function (id, data) {
            _this.setState({ app_language_avail: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize
            });
        });
        this.SID_AOIT = this.props.PartnersOffersInheritanceTypesAvail.Subscribe("*", function (id, data) {
            _this.setState({ offer_inheritance_types_avail: data.data });
        });
        this.setState({
            edit_mode: "LIST",
            partner: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            affilates_list: [],
            all_affilates: true,
            avail_affilates: [],
            app_currency_avail: [],
            app_language_avail: [],
            offer_inheritance_types_avail: []
        }, function () {
            _this.props.listAppCurrencyAvail.LoadData();
            _this.props.listAppLanguageAvail.LoadData();
            _this.props.listAffilatesAvail.LoadData();
            _this.props.PartnersOffersInheritanceTypesAvail.LoadData();
        });
    };
    PPartnersList.prototype.componentWillUnmount = function () {
        this.props.listAppCurrencyAvail.UnSubscribe(this.SID_AC);
        this.props.listAppLanguageAvail.UnSubscribe(this.SID_AL);
        this.props.listAffilatesAvail.UnSubscribe(this.SID_AA);
        this.props.state.UnSubscribe(this.SID_STATE);
        this.props.PartnersOffersInheritanceTypesAvail.UnSubscribe(this.SID_AOIT);
    };
    PPartnersList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", partner: null });
    };
    PPartnersList.prototype.onEditClick = function (partnerObj) {
        this.setState({ edit_mode: "EDIT", partner: partnerObj });
    };
    PPartnersList.prototype.onConfigClick = function (partnerObj) {
        this.setState({ edit_mode: "DETAILS", partner: partnerObj });
    };
    PPartnersList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", partner: null });
    };
    PPartnersList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PPartnersList.prototype.onSendBroadcastRawClick = function () {
        var _this = this;
        this.props.dlgSendBroadcastRawMsg
            .clearFields()
            .SetDialogTitle("Отправить текст сообщение")
            .SetMessageTitle("Заголовок сообщения")
            .SetMessageText("Текст сообщения")
            .SetPPrograms(this.state.avail_affilates)
            .SetLanguages(this.state.app_language_avail)
            .SetOnYesClick(function (msgTitle, msgText, pprogramId, langId) {
            _this.props.PartnersMessagesList.DoSendBroadcastRawMsg({
                pprogram_id: pprogramId,
                app_language_id: langId,
                message_title: msgTitle,
                message_text: msgText
            }, function (sent_count) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E ",
                    React.createElement("b", null,
                        "[",
                        sent_count,
                        "]"),
                    " \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439"));
            });
            _this.props.dlgSendBroadcastRawMsg.Close();
        })
            .Show();
    };
    PPartnersList.prototype.onBrandFilterChanged = function (allAffilates, affilateId, Action) {
        if (Action === "checkbox") {
            this.setState({ all_affilates: allAffilates });
        }
        if (Action === "add") {
            var new_list = this.state.affilates_list.slice();
            new_list.push(affilateId);
            this.setState({ affilates_list: new_list });
        }
        if (Action === "remove") {
            var new_list = this.state.affilates_list.slice();
            var index = new_list.indexOf(affilateId);
            if (index !== -1) {
                new_list.splice(index, 1);
            }
            this.setState({ affilates_list: new_list });
        }
    };
    PPartnersList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(PartnerEditor_1.default, { data: this.props.data, state: this.props.state, partner: null, onGoBack: this.onGoBackClick.bind(this), affilatesAvail: this.state.avail_affilates, appCurrencyAvail: this.state.app_currency_avail, appLanguageAvail: this.state.app_language_avail, offerInheritanceTypesAvail: this.state.offer_inheritance_types_avail }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(PartnerEditor_1.default, { data: this.props.data, state: this.props.state, partner: this.state.partner, onGoBack: this.onGoBackClick.bind(this), affilatesAvail: this.state.avail_affilates, appCurrencyAvail: this.state.app_currency_avail, appLanguageAvail: this.state.app_language_avail, offerInheritanceTypesAvail: this.state.offer_inheritance_types_avail }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(PartnersList_1.default, { data: this.props.data, state: this.props.state, pageNum: this.state.page_num, pageSize: this.state.page_size, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onConfigClick: this.onConfigClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), dlgPwd: this.props.dlgPwd, dlgView: this.props.dlgView, affilatesList: this.state.affilates_list, allAffilates: this.state.all_affilates, availAffilates: this.state.avail_affilates, onAffilateFilterChanged: this.onBrandFilterChanged.bind(this), onSendBroadcastRawClick: this.onSendBroadcastRawClick.bind(this), dlgSetTopPartner: this.props.dlgSetTopPartner }));
        }
        if (this.state.edit_mode === "DETAILS") {
            return (React.createElement(PartnerConfig_1.default, { state: this.props.state, listPartnerTrackers: this.props.listPartnersTrackers, listPartnerOffers: this.props.listPartnersOffers, listAvailOffers: this.props.listOffersAvail, record: this.state.partner, onGoBackClick: this.onGoBackClick.bind(this), PartnersPayDetailsList: this.props.PartnersPayDetailsList, PartnersBalancesList: this.props.PartnersBalancesList, PartnersMessagesList: this.props.PartnersMessagesList, ListAffilatesPayoutsAvail: this.props.ListAffilatesPayoutsAvail, PartnersAuthLogsList: this.props.PartnersAuthLogsList, dlgMessage: this.props.dlgMessage, ListPartnersBrandsAvail: this.props.ListPartnersBrandsAvail, ListPromoCodeTemplatesForBrandsAvail: this.props.ListPromoCodeTemplatesForBrandsAvail, ListPartnersPromoCodeTemplates: this.props.ListPartnersPromoCodeTemplates }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PPartnersList.prototype.render = function () {
        return this.getRenderObject();
    };
    PPartnersList.getPageDescription = function (state) {
        return {
            icon: "user-tie",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_par_partners + "-id",
            itemTitle: "Партнеры",
            route: routes_1.routes.page_par_partners,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PPartnersList;
}(React.Component));
exports.default = PPartnersList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_partners_list/ui/PPartnersList.tsx
// module id = 2430
// module chunks = 0